// Dark Theme
export const white100 = 'rgba(255, 255, 255, 1)'; // #fff
export const white80 = 'rgba(255, 255, 255, 0.8)';
export const white50 = 'rgba(255, 255, 255, 0.5)';
export const white30 = 'rgba(255, 255, 255, 0.3)';
export const white10 = 'rgba(255, 255, 255, 0.1)';
export const darkFirst = 'rgba(22, 22, 22, 1)'; // #161616
export const darkFirst80 = 'rgba(22, 22, 22, 0.8)';
export const darkFirst70 = 'rgba(22, 22, 22, 0.7)';
export const darkFirst50 = 'rgba(22, 22, 22, 0.5)';
export const darkFirst30 = 'rgba(22, 22, 22, 0.3)';
export const darkFirst10 = 'rgba(22, 22, 22, 0.1)';
export const darkSecond = 'rgba(18, 18, 18, 1)'; //#121212
export const darkModal = 'rgba(21, 21, 21, 1)';
export const darkGray = 'rgba(31, 31, 31, 1)';

// Light Theme
export const lightFirst = 'rgba(232, 232, 232, 1)';
export const lightSecond = 'rgba(246, 246, 247, 1)';
export const lightLast = 'rgba(252, 252, 252, 1)';

// Violet Theme
export const violetAccent = 'rgba(82, 85, 188, 1)';
export const violetSecondAccent = 'rgba(185, 189, 253, 1)';
export const violetLast = 'rgba(236, 237, 253, 1)';
export const violetLast40 = 'rgba(236, 237, 253, 0.4)';

// Priority
export const lowPriority = 'rgba(143, 161, 208, 1)';
export const mediumPriority = 'rgba(224, 156, 181, 1)';
export const highPriority = 'rgba(190, 219, 176, 1)'; // #bedbb0
